import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CmsService } from '../cms.service';
import * as PrismicDOM from 'prismic-dom';
import { ConnectService } from '../connect.service';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public home;
  public data;
  public connect = () => this.connectService.toggleConnect(true);
  
  public generateMarkup(data){
    return PrismicDOM.RichText.asHtml(data);
  }

  constructor(private cms:CmsService, private connectService:ConnectService, private route: ActivatedRoute, private titleService:Title) { }

  ngOnInit() {
    this.titleService.setTitle(`ThinSlabz®`);

    let data = this.route.snapshot.data;
    if (data && data.home) {
      this.home = data.home;
    } else {
      this.cms.getHome().subscribe((response) => {
        this.home = response;
        // console.log("Documents: ", response);
        
      });
    }

    
  }

}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/home/home.component.ts